import React, { useRef, useEffect } from 'react';
import MonthRangePicker from '../GlobalMonthPicker/MonthRangePicker/MonthRangePicker';
import calender from '../../../images/icons/calender.svg';
import DropLogo from '../../../images/icons/arrow_grey.svg';

const GlobalMonthPicker = ({
  autoRange,
  removeDropDown,
  styleObject = {},
  singlePicker,
  rangeValue,
  setRangeValue,
  maxMonth,
  validRange,
  multiValue,
  setMultiValue,
  onChangeSinglePicker,
  placeHolder
}) => {
  const myRef = useRef(null);

  return (
    <div
      className={
        (singlePicker ? ' w-44' : 'w-68') +
        ' relative h-8 leading-relaxed text-base  my-4 flex flex-row justify-around content-center mr-auto border border-blue-1100 bg-white rounded  z-10'
      }
      style={styleObject}
      onClick={() => {
        myRef.current.classList.toggle(['transform']);
        myRef.current.classList.toggle(['rotate-180']);
      }}
    >
      <div
        className="self-center mx-2 absolute left-0 z-0"
        style={{ width: 'fit-content' }}
      >
        <img className=" w-4 h-4 z-0" src={calender} alt="" />
      </div>
      <MonthRangePicker
        autoRange={autoRange}
        singlePicker={singlePicker}
        maxMonth={maxMonth}
        multiValue={multiValue}
        setMultiValue={setMultiValue}
        rangeValue={rangeValue}
        setRangeValue={setRangeValue}
        validRange={validRange} //{ min: 2013 }//[2008, 2011, 2012, 2014, 2016, 2018, 2020]
        onChangeSinglePicker={onChangeSinglePicker}
        placeHolder={placeHolder}
      />
      <div
        className={
          removeDropDown
            ? 'hidden'
            : 'self-center mx-2 absolute float-right right-0 z-0'
        }
        style={{ width: 'fit-content' }}
      >
        <img ref={myRef} className=" w-4 h-4 z-0" src={DropLogo} alt="" />
      </div>
    </div>
  );
};
export default GlobalMonthPicker;
